import React, { Fragment } from "react";
import { FiChevronDown } from "react-icons/fi";
import { Menu, Transition } from "@headlessui/react";

import Text from "./Text";
import Button from "./Button";
import { BUTTON_CONFIG } from "config/constants/Button";

export const DROPDOWN_ITEMS_TYPE = {
  SEPARATOR: 1,
  ITEM: 2,
};

function Dropdown({
  items = [],
  label = "Opciones",
  containerClassName = "",
  type = BUTTON_CONFIG.CLASS.SUCCESS,
}) {

  return <div className={containerClassName}>
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button as="div">
          <Button
            type={type}
            label={label}
            icon={<FiChevronDown aria-hidden="true" className="-mr-1 h-4 w-4" />} />
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 mt-1 w-56 rounded-md bg-white dark:bg-gray-800 border border-line dark:border-line-dark shadow-md z-50 focus:outline-none">
          <div className="p-1">
            {
              items.map((item, index) => {
                if (item.type === DROPDOWN_ITEMS_TYPE.SEPARATOR)
                  return <div key={index} className="bg-line dark:bg-line-dark my-1 h-px" />;
                return (<Menu.Item key={index}>
                  {({ active }) => (
                    <button
                      onClick={item.onClick}
                      className={`${active ? "bg-gray-100 dark:bg-gray-700" : ""} group flex w-full items-center gap-2 rounded px-2.5 py-1.5 text-sm`}
                    >
                      {item?.icon ? item.icon : null}
                      {item?.label ? <Text color="text-gray-700 dark:text-gray-200">{item.label}</Text> : null}
                    </button>
                  )}
                </Menu.Item>);
              })
            }
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  </div>;
}

export default Dropdown;
